import * as styles from "./UpsellModal.css";

import type { MembershipOption } from "@shared/graphql.types";

import React from "react";
import {
  Button,
  Drawer,
  MarkdownRenderer,
  Typography
} from "@shared/ui.primitives";
import { CloseIcon } from "@shared/ui.icons";

type Props = {
  membership: Pick<MembershipOption, "saving" | "perks" | "terms">;
  onDismiss: (trackModuleContent?: string) => void;
  isOpen: boolean;
  onContinueWithFreeTrial: () => void;
  onContinueWithWithoutFreeTrial: () => void;
};

export const UpsellModal: React.FC<Props> = ({
  membership,
  onDismiss,
  isOpen,
  onContinueWithFreeTrial,
  onContinueWithWithoutFreeTrial
}) => {
  return (
    <Drawer
      handleDismiss={() => onDismiss("Clicked outside")}
      id="upsell-modal"
      ariaDescription="Upsell modal"
      ariaLabel="Upsell"
      isOpen={isOpen}
      variant="bottom-sheet"
    >
      <Drawer.Header handleDismiss={() => onDismiss("Clicked outside")}>
        <div className={styles.headerWrapper}>
          <div className={styles.headerTitle}>
            <Typography as="h3" variant="subheader-3">
              Save{" "}
              <Typography as="span" variant="subheader-3" colour="accent-dark">
                {membership?.saving}
              </Typography>{" "}
              on this
            </Typography>
          </div>
          <button
            onClick={() => onDismiss("Modal closed with X button")}
            aria-label="Close drawer"
            className={styles.closeButton}
          >
            <CloseIcon className={styles.closeIcon} />
          </button>
        </div>
      </Drawer.Header>
      <Drawer.Body>
        <div className={styles.smallPrint}>
          <Typography as="span" variant="subheader-7" colour="primary-dark">
            With a free 14-day trial of our Beauty Pie+ starter membership
          </Typography>{" "}
        </div>
        {membership.perks && (
          <MarkdownRenderer
            className={styles.membershipPerks}
            as="li"
            content={membership.perks}
          />
        )}
        <div className={styles.smallPrint}>
          <Typography variant="body-sm" colour="primary-dark">
            {membership.terms.termsContent}
          </Typography>{" "}
        </div>
      </Drawer.Body>
      <Drawer.Footer>
        <Button
          variant="secondary"
          width="full"
          onClick={() => {
            onContinueWithWithoutFreeTrial();
          }}
          text="No, Thanks"
        />

        <Button
          variant="primary"
          width="full"
          onClick={() => {
            onContinueWithFreeTrial();
          }}
          text="Add Free Trial"
        />
      </Drawer.Footer>
    </Drawer>
  );
};
